// @ts-nocheck
/**
 * Planner swipe step, full-bleed: the recipe video fills the phone from the top edge (under the then
 * transparent top bar) to the bottom (under the tab bar); stage nav, week strip and CTA float over it.
 * CSS can't know how far the step sits from those edges or how tall the week strip and CTA are, so this
 * measures them and hands them over as custom properties (see "swipe step: full-bleed" in
 * assets/vhp-planner-tinder.css). Without it (no is-bleed class) the card stays inset between week strip
 * and CTA.
 *
 * The planner (assets/vhp-planner-funnel.js) runs after this and builds / switches its screens, so the
 * elements are looked up fresh on every measure, and a screen switch (hidden toggles) triggers one.
 */
(() => {
  'use strict';

  const phone = document.querySelector('.app-phone');
  if (!phone || !('ResizeObserver' in window) || !('MutationObserver' in window)) return;

  const shown = (el) => Boolean(el) && !el.hidden && el.getClientRects().length > 0;
  let observed = null;

  const measure = () => {
    const screen = document.querySelector('.vhp-screen--swipe');
    if (!screen || !screen.querySelector('.vhp-plan-feed')) return;
    const head = screen.querySelector('.vhp-sw-head');
    const dock = screen.querySelector('.vhp-sw-dock');
    if (observed !== screen) {
      observed = screen;
      ro.disconnect();
      [screen, head, dock].forEach((el) => el && ro.observe(el));
    }
    if (!shown(screen)) return;
    // layout distances (scroll-independent): step box against the phone column. The step's own rect is
    // useless while it turns in (cube / slide transform, the first measure runs right when it is unhidden),
    // so its box comes from the offset parent (.vhp-screens, never transformed) plus its layout offsets.
    const base = screen.offsetParent;
    if (!base) return;
    const b = base.getBoundingClientRect();
    const left = b.left + base.clientLeft + screen.offsetLeft;
    const top = b.top + base.clientTop + screen.offsetTop;
    const s = { left, top, right: left + screen.offsetWidth, bottom: top + screen.offsetHeight };
    const p = phone.getBoundingClientRect();
    const px = (name, value) => screen.style.setProperty(name, `${Math.max(0, Math.round(value))}px`);
    px('--sw-bleed-top', s.top - p.top);
    px('--sw-bleed-bottom', p.bottom - s.bottom);
    px('--sw-bleed-left', s.left - p.left);
    px('--sw-bleed-right', p.right - s.right);
    px('--sw-head-h', shown(head) ? head.offsetHeight : 0);
    px('--sw-dock-h', shown(dock) ? dock.offsetHeight : 0);
    screen.classList.add('is-bleed');
  };

  const ro = new ResizeObserver(() => measure());
  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      measure();
    });
  };
  new MutationObserver(queue).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['hidden'],
  });
  window.addEventListener('resize', queue);
  window.addEventListener('load', queue);
  measure();
})();
